import { render, staticRenderFns } from "./fawry-checkout.vue?vue&type=template&id=548224ad"
import script from "./fawry-checkout.vue?vue&type=script&lang=js"
export * from "./fawry-checkout.vue?vue&type=script&lang=js"
import style0 from "./fawry-checkout.vue?vue&type=style&index=0&id=548224ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports